export default [
  {
    path: "extention",
    name: "extentions",
    component: () => import("@/views/adminPanel/pages/extention/Extention.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "extention-OrderConfirm",
    name: "extentions-OrderConfirm",
    component: () =>
      import("@/views/adminPanel/pages/extention/components/OrderConfirm.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "extension-Myrequest",
    name: "extension-Myrequest",
    component: () =>
      import("@/views/adminPanel/pages/extention/components/MyRequest.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "extension-Myassets",
    name: "extension-Myassets",
    component: () =>
      import("@/views/adminPanel/pages/extention/components/MyAssets.vue"),
    meta: {
      rule: "editor",
    },
  },
];
